import React, { useEffect, useState } from 'react';

// App-wide connectivity banner - mirrors the mobile app's NetworkBanner.js
// (same message/color), adapted to the browser's native online/offline
// events instead of NetInfo. A small, persistent, non-blocking bar that
// appears the instant the browser goes offline and disappears the instant
// it's back, on every page, regardless of what the user is doing. It never
// navigates away or blocks input (pointerEvents: 'none') - it only explains
// why requests are failing, it doesn't interrupt anything.
const NetworkBanner = () => {
    const [isOnline, setIsOnline] = useState(
        typeof navigator === 'undefined' ? true : navigator.onLine
    );

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <div
            role="status"
            aria-live="polite"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 99999,
                textAlign: 'center',
                padding: '8px 12px',
                background: '#dc2626',
                color: '#fff',
                fontWeight: 700,
                fontSize: 13,
                letterSpacing: '0.2px',
                transform: isOnline ? 'translateY(-100%)' : 'translateY(0)',
                transition: 'transform 0.25s ease',
                pointerEvents: 'none',
            }}
        >
            No Internet Connection
        </div>
    );
};

export default NetworkBanner;
